export default {
    title: 'Innovation field',
    macrotrends: 'Macro-trends',
    alternative: 'There are no macro-trends in this section',
    contactperson: 'Contact person'
}
